import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { onDisableWindowScroll, onEnableWindowScroll } from "../../utilities/helper";

const initialState = {
    show: false,
    countryCode: "",
    status: "idle",
};

export const countrySelectorSlice = createSlice({
    name: "countrySelector",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        showHideCountrySelector: (state, action) => {
            state.show = action.payload;
        },
        updateCountryCode: (state, action) => {
            state.countryCode = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const { showHideCountrySelector, updateCountryCode } = countrySelectorSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.buildMyHoliday.value)`
export const selectShowStateCountrySelector = (state) => state.countrySelector.show;
export const selectCountryCode = (state) => state.countrySelector.countryCode;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const handleStateCountrySelector = () => (dispatch, getState) => {
    const { show } = getState().countrySelector;
    dispatch(showHideCountrySelector(!show));
};

export default countrySelectorSlice.reducer;
